import { PayloadAction, createSlice } from "@reduxjs/toolkit";

type T_PseudoLoginSliceState = {
  source: string;
  isPseudoLoggedIn: boolean;
  mobileNumber: string;
  expireInMinutes: number;
  createdAt: string;
  isLinkExpired?: boolean;
  adminIdFromPseudo: string;
};

const initialState: T_PseudoLoginSliceState = {
  source: "",
  isPseudoLoggedIn: false,
  mobileNumber: "",
  createdAt: "",
  expireInMinutes: 0,
  isLinkExpired: false,
  adminIdFromPseudo: "",
};

export const PseudoLoginSlice = createSlice({
  name: "PseudoLoginSlice",
  initialState: initialState,
  reducers: {
    updatePseudoLoginState: (
      state: T_PseudoLoginSliceState,
      action: PayloadAction<T_PseudoLoginSliceState>,
    ) => {
      return { ...state, ...action.payload };
    },
    updateIsLinkExpired: (
      state: T_PseudoLoginSliceState,
      action: PayloadAction<boolean>,
    ) => {
      return { ...state, isLinkExpired: action.payload };
    },
    resetPseudoLoginSlice: () => {
      return { ...initialState };
    },
  },
});

export const { reducer: PseudoLoginSliceReducer } = PseudoLoginSlice;
export const PseudoLoginSliceKey = PseudoLoginSlice.reducerPath;
export const {
  updatePseudoLoginState,
  resetPseudoLoginSlice,
  updateIsLinkExpired,
} = PseudoLoginSlice.actions;
